__turbopack_context__.v({
  "className": "instrument_serif_7e86a94e-module__bTA2vq__className",
});
